// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__or20o","desabilitar":"OptionSelect_desabilitar__Xptk2","focado":"OptionSelect_focado__yefuf","novo":"OptionSelect_novo__Tgea1"};